/* ==========================================================================
   CHRONAL — theme.js
   No dependencies. Progressive enhancement only.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { el && el.addEventListener(ev, fn, o); };

  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      if (val === null) { window.localStorage.removeItem(key); return null; }
      window.localStorage.setItem(key, val); return val;
    } catch (e) { return null; }
  }

  function money(cents) {
    var fmt = window.CHRONAL && window.CHRONAL.moneyFormat;
    var amount = (cents / 100).toFixed(2);
    if (!fmt) return amount + ' €';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount.replace('.', ','))
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  function t(key, fallback) {
    var s = window.CHRONAL && window.CHRONAL.strings;
    return (s && s[key]) || fallback;
  }

  /* ======================================================================
     1. DAY / NIGHT — the brand's core mechanic
     ====================================================================== */
  var Time = {
    dayStart: 6,
    nightStart: 20,
    init: function () {
      var root = document.documentElement;
      this.dayStart   = parseInt(root.getAttribute('data-day-start') || '6', 10);
      this.nightStart = parseInt(root.getAttribute('data-night-start') || '20', 10);
      this.mode = store('chronal:theme');
      this.apply(this.mode || this.natural(), true);

      $$('[data-theme-toggle]').forEach(function (btn) {
        on(btn, 'click', function () { Time.toggle(); });
      });

      // re-check the clock every minute while the visitor is on auto
      setInterval(function () {
        if (!store('chronal:theme')) Time.apply(Time.natural(), true);
      }, 60000);

      this.clock();
    },
    natural: function () {
      var h = new Date().getHours();
      return (h >= this.nightStart || h < this.dayStart) ? 'night' : 'day';
    },
    apply: function (mode, silent) {
      var root = document.documentElement;
      if (root.getAttribute('data-theme') === mode) { this.sync(mode); return; }
      var run = function () {
        root.setAttribute('data-theme', mode);
        Time.sync(mode);
        document.dispatchEvent(new CustomEvent('chronal:theme', { detail: { mode: mode } }));
      };
      if (silent || REDUCED) { run(); return; }
      var sweep = $('.theme-sweep');
      if (!sweep) { run(); return; }
      sweep.classList.remove('is-running');
      void sweep.offsetWidth;
      sweep.classList.add('is-running');
      setTimeout(run, 420);
      setTimeout(function () { sweep.classList.remove('is-running'); }, 900);
    },
    sync: function (mode) {
      $$('[data-theme-toggle]').forEach(function (btn) {
        var label = $('[data-theme-label]', btn);
        if (label) label.textContent = mode === 'night' ? t('night', 'Night') : t('day', 'Day');
        btn.setAttribute('aria-label', (mode === 'night' ? t('night', 'Night') : t('day', 'Day')) + ' — ' + t('switchMode', 'Modus wechseln'));
      });
      var meta = $('meta[name="theme-color"]');
      if (meta) meta.setAttribute('content', mode === 'night' ? '#190b28' : '#eaebd6');
      $$('[data-night-only]').forEach(function (el) { el.hidden = mode !== 'night'; });
      $$('[data-day-only]').forEach(function (el) { el.hidden = mode !== 'day'; });
    },
    toggle: function () {
      var next = document.documentElement.getAttribute('data-theme') === 'night' ? 'day' : 'night';
      store('chronal:theme', next);
      this.apply(next);
    },
    clock: function () {
      var nodes = $$('[data-clock]');
      if (!nodes.length) return;
      var tickFn = function () {
        var d = new Date();
        var p = function (n) { return n < 10 ? '0' + n : '' + n; };
        var str = p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
        nodes.forEach(function (n) { n.textContent = str; });
      };
      tickFn();
      setInterval(tickFn, 1000);
    }
  };

  /* ======================================================================
     2. Scroll reveal
     ====================================================================== */
  function reveals() {
    var targets = $$('[data-reveal], [data-stagger], .line-reveal, .char-reveal');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || REDUCED) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* split headlines into animated lines */
  function splitText() {
    if (REDUCED) return;
    $$('[data-split="chars"]').forEach(function (el) {
      if (el.dataset.splitDone) return;
      var text = el.textContent;
      el.textContent = '';
      el.classList.add('char-reveal');
      text.split('').forEach(function (ch, i) {
        var s = document.createElement('i');
        s.textContent = ch === ' ' ? ' ' : ch;
        s.style.transitionDelay = (i * 26) + 'ms';
        el.appendChild(s);
      });
      el.dataset.splitDone = '1';
    });
  }

  /* ======================================================================
     3. Header behaviour
     ====================================================================== */
  function header() {
    var el = $('[data-header]');
    if (!el) return;
    var last = 0, ticking = false;
    var setH = function () {
      document.documentElement.style.setProperty('--header-h', el.offsetHeight + 'px');
    };
    setH();
    on(window, 'resize', setH);
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        el.setAttribute('data-stuck', y > 12 ? 'true' : 'false');
        if (!el.hasAttribute('data-no-autohide')) {
          el.setAttribute('data-hidden', (y > last && y > 400 && !document.body.hasAttribute('data-scroll-locked')) ? 'true' : 'false');
        }
        last = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ======================================================================
     4. Drawers (menu / cart / search / filters)
     ====================================================================== */
  var Drawer = {
    open: null,
    lastFocus: null,
    show: function (id) {
      var d = document.getElementById(id);
      if (!d) return;
      if (this.open && this.open !== d) this.hide();
      this.lastFocus = document.activeElement;
      d.setAttribute('data-open', 'true');
      d.removeAttribute('aria-hidden');
      var ov = $('[data-overlay]');
      if (ov) ov.setAttribute('data-open', 'true');
      document.body.setAttribute('data-scroll-locked', '');
      this.open = d;
      $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () {
        var f = d.querySelector('[data-autofocus], button, a[href], input, select, textarea');
        if (f) f.focus();
      }, 260);
    },
    hide: function () {
      var d = this.open;
      if (!d) return;
      d.setAttribute('data-open', 'false');
      d.setAttribute('aria-hidden', 'true');
      var ov = $('[data-overlay]');
      if (ov) ov.setAttribute('data-open', 'false');
      document.body.removeAttribute('data-scroll-locked');
      $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      this.open = null;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    init: function () {
      on(document, 'click', function (e) {
        var opener = e.target.closest('[data-drawer-open]');
        if (opener) { e.preventDefault(); Drawer.show(opener.getAttribute('data-drawer-open')); return; }
        if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-overlay]')) { Drawer.hide(); }
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && Drawer.open) { Drawer.hide(); return; }
        if (e.key !== 'Tab' || !Drawer.open) return;
        var f = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', Drawer.open)
                  .filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], lastEl = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
      });
    }
  };

  /* ======================================================================
     5. Cart
     ====================================================================== */
  var Cart = {
    routes: function () { return (window.CHRONAL && window.CHRONAL.routes) || {}; },
    init: function () {
      on(document, 'submit', function (e) {
        var form = e.target.closest('form[data-cart-add]');
        if (!form) return;
        e.preventDefault();
        Cart.add(form);
      });
      on(document, 'click', function (e) {
        var minus = e.target.closest('[data-qty-minus]');
        var plus  = e.target.closest('[data-qty-plus]');
        var rm    = e.target.closest('[data-cart-remove]');
        if (minus || plus) {
          var box = (minus || plus).closest('.qty');
          var input = $('input', box);
          var v = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
          input.value = Math.max(parseInt(input.min || '0', 10), v);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (rm) { e.preventDefault(); Cart.change(rm.getAttribute('data-key'), 0); }
      });
      on(document, 'change', function (e) {
        var input = e.target.closest('[data-cart-qty]');
        if (!input) return;
        Cart.change(input.getAttribute('data-key'), parseInt(input.value || '0', 10));
      });
    },
    busy: function (state) {
      $$('[data-cart-drawer-body]').forEach(function (b) { b.style.opacity = state ? '.45' : '1'; b.style.pointerEvents = state ? 'none' : ''; });
    },
    add: function (form) {
      var btn = $('[data-add-btn]', form) || $('button[type="submit"]', form);
      var label = btn ? $('span', btn) : null;
      var original = label ? label.textContent : '';
      if (label) label.textContent = t('adding', 'Wird hinzugefügt…');
      if (btn) btn.setAttribute('aria-disabled', 'true');

      fetch(this.routes().cartAdd + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'error');
          if (label) label.textContent = t('added', 'Im Warenkorb ✓');
          return Cart.refresh(true);
        })
        .catch(function (err) {
          if (label) label.textContent = t('soldOut', 'Nicht verfügbar');
          var box = $('[data-cart-error]', form);
          if (box) { box.textContent = err.message; box.hidden = false; }
        })
        .then(function () {
          setTimeout(function () {
            if (label) label.textContent = original;
            if (btn) btn.removeAttribute('aria-disabled');
          }, 1600);
        });
    },
    change: function (key, qty) {
      this.busy(true);
      fetch(this.routes().cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(false); })
        .then(function () { Cart.busy(false); })
        .catch(function () { Cart.busy(false); });
    },
    refresh: function (openDrawer) {
      return fetch(this.routes().cart + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-inner]');
          var target = $('[data-cart-drawer-inner]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
          return fetch(Cart.routes().cart + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (n) {
            n.textContent = cart.item_count;
            n.setAttribute('data-visible', cart.item_count > 0 ? 'true' : 'false');
            n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump');
          });
          $$('[data-cart-total]').forEach(function (n) { n.textContent = money(cart.total_price); });
          document.dispatchEvent(new CustomEvent('chronal:cart', { detail: cart }));
          if (openDrawer) Drawer.show('cart-drawer');
          if (document.body.classList.contains('template-cart')) window.location.reload();
        });
    }
  };

  /* ======================================================================
     6. Marquee — duplicate track so the loop is seamless
     ====================================================================== */
  function marquees() {
    $$('.marquee, .strip').forEach(function (m) {
      var track = $('.marquee__track, .strip__track', m);
      if (!track || track.dataset.cloned) return;
      var needed = Math.ceil(m.offsetWidth / Math.max(track.offsetWidth, 1)) + 1;
      for (var i = 0; i < Math.max(needed, 1); i++) {
        var clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.cloned = '1';
        m.appendChild(clone);
      }
      track.dataset.cloned = '1';
    });
  }

  /* scroll-velocity nudge on marquees */
  function marqueeVelocity() {
    if (REDUCED) return;
    var lastY = window.scrollY, offset = 0, raf;
    var loop = function () {
      var y = window.scrollY;
      var v = (y - lastY);
      lastY = y;
      offset += v * 0.35;
      offset *= 0.92;
      if (Math.abs(offset) < 0.05) offset = 0;
      $$('.marquee').forEach(function (m) {
        $$('.marquee__track', m).forEach(function (tr) {
          tr.style.setProperty('--marquee-offset', offset.toFixed(2) + 'px');
        });
      });
      raf = window.requestAnimationFrame(loop);
    };
    raf = window.requestAnimationFrame(loop);
  }

  /* ======================================================================
     7. Magnetic buttons
     ====================================================================== */
  function magnetic() {
    if (REDUCED || window.matchMedia('(hover:none)').matches) return;
    $$('[data-magnetic]').forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-magnetic')) || 0.28;
      on(el, 'mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * strength;
        var y = (e.clientY - r.top - r.height / 2) * strength;
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      on(el, 'mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ======================================================================
     8. Parallax
     ====================================================================== */
  function parallax() {
    var els = $$('[data-parallax]');
    if (!els.length || REDUCED) return;
    var ticking = false;
    var run = function () {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (-progress * speed * 100).toFixed(2) + 'px,0)';
      });
      ticking = false;
    };
    on(window, 'scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ======================================================================
     9. Countdown
     ====================================================================== */
  function countdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var target = el.getAttribute('data-countdown');
      var mode = el.getAttribute('data-countdown-mode') || 'daily';

      function targetTime() {
        if (mode === 'daily') {
          var hour = parseInt(target, 10);
          if (isNaN(hour)) hour = 20;
          var now = new Date();
          var next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, 0, 0, 0);
          if (next.getTime() <= now.getTime()) next.setDate(next.getDate() + 1);
          return next.getTime();
        }
        var parsed = new Date(String(target).replace(' ', 'T'));
        return isNaN(parsed.getTime()) ? Date.now() : parsed.getTime();
      }

      var out = {
        days: $('[data-unit="days"] .countdown__num', el),
        hours: $('[data-unit="hours"] .countdown__num', el),
        minutes: $('[data-unit="minutes"] .countdown__num', el),
        seconds: $('[data-unit="seconds"] .countdown__num', el)
      };
      var shown = { days: null, hours: null, minutes: null, seconds: null };
      var expired = false;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function put(key, value) {
        var node = out[key];
        if (!node || shown[key] === value) return;   // nur schreiben, wenn sich was aendert
        shown[key] = value;
        node.textContent = value;
      }

      /* Ein rAF-Loop statt setInterval: setInterval driftet und laesst
         Sekunden ausfallen, sobald der Tab kurz beschaeftigt ist — genau
         das sieht abgehackt aus. Wir lesen stattdessen jeden Frame die
         echte Uhr und schreiben nur, wenn sich eine Ziffer geaendert hat. */
      function frame() {
        var diff = targetTime() - Date.now();
        if (diff <= 0) {
          diff = 0;
          if (!expired) {
            expired = true;
            el.setAttribute('data-expired', 'true');
            var scope = el.closest('[data-countdown-scope]') || document;
            var done = $('[data-countdown-done]', scope);
            if (done) done.hidden = false;
          }
        } else if (expired) {
          expired = false;
          el.removeAttribute('data-expired');
        }
        var total = Math.floor(diff / 1000);
        put('days', pad(Math.floor(total / 86400)));
        put('hours', pad(Math.floor(total / 3600) % 24));
        put('minutes', pad(Math.floor(total / 60) % 60));
        put('seconds', pad(total % 60));
        window.requestAnimationFrame(frame);
      }

      if (REDUCED || !window.requestAnimationFrame) {
        var tick = function () {
          var total = Math.max(0, Math.floor((targetTime() - Date.now()) / 1000));
          put('days', pad(Math.floor(total / 86400)));
          put('hours', pad(Math.floor(total / 3600) % 24));
          put('minutes', pad(Math.floor(total / 60) % 60));
          put('seconds', pad(total % 60));
        };
        tick();
        setInterval(tick, 500);
      } else {
        window.requestAnimationFrame(frame);
      }
    });
  }

  /* ======================================================================
     10. Product variants
     ====================================================================== */
  function variants() {
    $$('[data-variant-picker]').forEach(function (root) {
      var dataEl = $('[data-variant-json]', root);
      if (!dataEl) return;
      var list;
      try { list = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var form = root.closest('form') || $('form[data-cart-add]');
      var idInput = form ? $('[name="id"]', form) : null;

      var update = function () {
        var chosen = $$('input[type="radio"]:checked', root).map(function (i) { return i.value; });
        var match = list.filter(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        })[0];

        // grey out combinations that don't exist
        $$('.option__pill', root).forEach(function (pill) {
          var input = $('input', pill);
          if (!input) return;
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          var test = chosen.slice();
          test[idx] = input.value;
          var found = list.filter(function (v) {
            return test.every(function (val, i) { return i === idx ? v.options[i] === val : (chosen[i] ? v.options[i] === chosen[i] : true); });
          })[0];
          pill.setAttribute('data-unavailable', (found && found.available) ? 'false' : 'true');
        });

        var priceEl = $('[data-variant-price]', root.closest('[data-product-root]') || document);
        var btn = form ? $('[data-add-btn]', form) : null;
        var btnLabel = btn ? $('span', btn) : null;

        if (!match) {
          if (btn) { btn.setAttribute('aria-disabled', 'true'); }
          if (btnLabel) btnLabel.textContent = t('unavailable', 'Nicht verfügbar');
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) {
          priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
            ? '<span class="price__was">' + money(match.compare_at_price) + '</span><span class="price__now">' + money(match.price) + '</span>'
            : money(match.price);
        }
        if (btn) {
          if (match.available) { btn.removeAttribute('aria-disabled'); if (btnLabel) btnLabel.textContent = t('addToCart', 'In den Warenkorb'); }
          else { btn.setAttribute('aria-disabled', 'true'); if (btnLabel) btnLabel.textContent = t('soldOut', 'Ausverkauft'); }
        }
        // swap main image if the variant has one
        if (match.featured_media_id) {
          var media = $('[data-media-id="' + match.featured_media_id + '"]');
          if (media) media.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'nearest' });
        }
        // reflect in the URL so the variant is shareable
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      };

      $$('input[type="radio"]', root).forEach(function (i) { on(i, 'change', update); });
      update();
    });
  }

  /* sticky mobile buy bar */
  function stickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.setAttribute('data-visible', entries[0].isIntersecting ? 'false' : 'true');
    }, { rootMargin: '0px 0px -30% 0px' });
    io.observe(anchor);
  }

  /* ======================================================================
     11. Predictive search
     ====================================================================== */
  function search() {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    if (!input || !results) return;
    var timer, controller;
    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = (window.CHRONAL.routes.predictive || '/search/suggest') +
                  '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
            reveals();
          })
          .catch(function () {});
      }, 260);
    });
  }

  /* ======================================================================
     12. Misc
     ====================================================================== */
  function lazyFade() {
    $$('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) img.classList.add('is-loaded');
      else on(img, 'load', function () { img.classList.add('is-loaded'); });
    });
  }

  function boot() {
    var b = $('.boot');
    if (!b) return;
    var done = function () { b.setAttribute('data-done', 'true'); setTimeout(function () { b.remove(); }, 700); };
    if (document.readyState === 'complete') setTimeout(done, 250);
    else on(window, 'load', function () { setTimeout(done, 250); });
    setTimeout(done, 3000); // never trap the visitor
  }

  function accordionExclusive() {
    $$('[data-accordion-exclusive]').forEach(function (group) {
      $$('details', group).forEach(function (d) {
        on(d, 'toggle', function () {
          if (!d.open) return;
          $$('details', group).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function initAll() {
    Time.init();
    Drawer.init();
    Cart.init();
    header();
    splitText();
    reveals();
    marquees();
    marqueeVelocity();
    magnetic();
    parallax();
    countdowns();
    variants();
    stickyBuy();
    search();
    lazyFade();
    accordionExclusive();
    boot();
  }

  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', initAll);
  else initAll();

  // Shopify theme editor hooks
  document.addEventListener('shopify:section:load', function () {
    splitText(); reveals(); marquees(); magnetic(); countdowns(); variants(); lazyFade();
  });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  window.CHRONAL = window.CHRONAL || {};
  window.CHRONAL.Drawer = Drawer;
  window.CHRONAL.Cart = Cart;
  window.CHRONAL.Time = Time;
})();
